export function setLocalizationParams(str, config) {
	if (config.country) {
		str = str.replace(new RegExp('{country}', 'g'), config.country);
	}
	if (config.country && config.language) {
		str = str.replace(new RegExp('{locale}', 'g'), `${config.language}_${config.country}`);
	}

	if (config.locale) {
		str = str.replace(new RegExp('{locale}', 'g'), `${config.locale}`);
	}

	if (config.brand) {
		str = str.replace(new RegExp('{brand}', 'g'), config.brand);
	}

	return str;
}


// WEBPACK FOOTER //
// ./buttons/utils/localizationHelpers.js